import { Box, CircularProgress, CssBaseline } from "@mui/material";
import { useCheckAuthMutation, useGetUserQuery } from "features/auth/auth";
import { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "./containers/LoginPage";
import ResetPasswordPage from "./containers/ResetPasswordPage";
import ResetPasswordWithTokenPage from "./containers/ResetPasswordWithTokenPage";
import VerifyEmailPage from "./containers/VerifyEmailPage";
import AccountSettingsPage from "./containers/AccountSettingsPage";
import SetEmailPromptPage from "./containers/SetEmailPromptPage";
// import FileSystemPage from "containers/FileSystemPage";
import AdminRoute from "components/common/AdminRoute";
import ProtectedRoute from "components/common/ProtectedRoute";
import PublicRoute from "components/common/PublicRoute";
import ResetPasswordRoute from "components/common/ResetPasswordRoute";
import ChatPage from "containers/ChatPage";
import HomePage from "containers/HomePage";
import IntegrationsPage from "containers/IntegrationsPage";
import IntegrationDetailsPage from "containers/IntegrationDetailsPage";
import { useAppSelector } from "features/store";

function App() {
  const [checkAuth] = useCheckAuthMutation();
  const [authInProgress, setAuthInProgress] = useState(true);

  const { isAuthenticated, user } = useAppSelector((state) => state.auth);
  const { isLoading: userLoading } = useGetUserQuery(undefined, {
    skip: !isAuthenticated,
  });

  useEffect(() => {
    async function performAuthCheck() {
      try {
        await checkAuth().unwrap();
      } catch (error) {
      } finally {
        setAuthInProgress(false);
      }
    }
    performAuthCheck();
  }, [checkAuth]);

  if (authInProgress || userLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <CssBaseline />
      <div style={{ backgroundColor: "white" }}>
        <BrowserRouter>
          <Routes>
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <LoginPage />
                </PublicRoute>
              }
            />
            <Route
              path="/reset-password"
              element={
                <ResetPasswordRoute>
                  <ResetPasswordPage />
                </ResetPasswordRoute>
              }
            />
            <Route
              path="/reset-password/:token"
              element={
                <PublicRoute>
                  <ResetPasswordWithTokenPage />
                </PublicRoute>
              }
            />
            <Route
              path="/verify-email/:token"
              element={
                <PublicRoute>
                  <VerifyEmailPage />
                </PublicRoute>
              }
            />
            <Route
              path="/set-email"
              element={
                <ProtectedRoute>
                  <SetEmailPromptPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/integrations"
              element={
                <AdminRoute>
                  <IntegrationsPage />
                </AdminRoute>
              }
            />
            <Route
              path="/integrations/:id"
              element={
                <AdminRoute>
                  <IntegrationDetailsPage />
                </AdminRoute>
              }
            />
            <Route
              path="/chat"
              element={
                <ProtectedRoute>
                  <ChatPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/account-settings"
              element={
                <ProtectedRoute>
                  <AccountSettingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <HomePage />
                </ProtectedRoute>
              }
            />
            {/* Catch-all route for 404 errors */}
            <Route
              path="*"
              element={
                isAuthenticated && user && !user.is_pass_reset ? (
                  <Navigate to="/" replace />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
          </Routes>
        </BrowserRouter>
      </div>
    </>
  );
}

export default App;
